import React, { useEffect } from "react";

const XmlSiteMap: React.FC = () => {
	useEffect(() => {
		// Set the document content type for search engines
		const metaContentType = document.querySelector(
			'meta[http-equiv="Content-Type"]'
		);
		if (metaContentType) {
			metaContentType.setAttribute("content", "application/xml; charset=utf-8");
		} else {
			const meta = document.createElement("meta");
			meta.setAttribute("http-equiv", "Content-Type");
			meta.setAttribute("content", "application/xml; charset=utf-8");
			document.head.appendChild(meta);
		}
	}, []);

	const baseUrl = window.location.origin;
	const currentDate = new Date().toISOString();

	const urls = [
		{ loc: `${baseUrl}/`, priority: "1.0", changefreq: "daily" },
		{ loc: `${baseUrl}/landing`, priority: "0.9", changefreq: "weekly" },
		{ loc: `${baseUrl}/dashboard`, priority: "0.8", changefreq: "daily" },
		{ loc: `${baseUrl}/login`, priority: "0.6", changefreq: "monthly" },
		{ loc: `${baseUrl}/terms`, priority: "0.5", changefreq: "yearly" },
		{ loc: `${baseUrl}/privacy`, priority: "0.5", changefreq: "yearly" }
	];

	const xmlContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls
	.map(
		(url) => `  <url>
    <loc>${url.loc}</loc>
    <lastmod>${currentDate}</lastmod>
    <changefreq>${url.changefreq}</changefreq>
    <priority>${url.priority}</priority>
  </url>`
	)
	.join("\n")}
</urlset>`;

	return (
		<pre
			style={{
				margin: 0,
				padding: "20px",
				fontFamily: "monospace",
				fontSize: "14px",
				lineHeight: "1.5",
				whiteSpace: "pre-wrap",
				backgroundColor: "#f5f5f5"
			}}
		>
			{xmlContent}
		</pre>
	);
};

export default XmlSiteMap;
